<!-- Navbar -->
<nav class="fixed top-0 left-0 right-0 z-50 transition-all duration-300" [ngClass]="{
    'shadow-sm border-b border-gray-200 backdrop-blur-sm bg-white/50': isScrolled,
    'bg-transparent border-transparent': !isScrolled && isHomeRoute
  }">

  <div class="max-w-7xl mx-auto px-4">
    <div class="relative">

      <div class="flex justify-between items-center h-16">

        <!-- Logo -->
        <a href="/" class="flex items-center">
          <img [src]="logoImagePath" alt="CleverDeals.net" class="h-10" />
          <span class="ml-3 text-sm font-medium hidden md:block" [ngClass]="{
              'text-gray-800': isScrolled,
              'text-white': !isScrolled
            }">
            Smart Deals, Clever Savings
          </span>
        </a>

        <!-- Right Side (Categories + Profile) -->
        <div class="flex items-center space-x-4">

          <!-- Categories Dropdown -->
          <div class="relative">
            <button (click)="toggleCategoryDropdown()"
              class="flex items-center px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-lg transition-colors text-sm">
              Categories
              <i class="fas fa-chevron-down ml-2 text-sm"></i>
            </button>

            <!-- Dropdown Menu -->
            <div *ngIf="showCategoryDropdown"
              class="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
              <ul class="py-2">
                <!-- All Categories Option -->
                <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
                  (click)="selectCategory(null)">
                  <span>All Categories</span>
                </li>

                <!-- Divider -->
                <li class="border-t my-1"></li>

                <!-- Loop through categories -->
                <li *ngFor="let cat of categories"
                  class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
                  (click)="selectCategory(cat.value)">

                  <span>{{ cat.label }}</span>
                  <span
                    class="ml-2 bg-yellow-400 text-black text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                    {{ cat.dealCount }}
                  </span>
                </li>
              </ul>

            </div>
          </div>

          <!-- Profile -->
          <div class="flex items-center space-x-3 cursor-pointer" (click)="openUserProfile()">
            <ng-container *ngIf="customerName">
              <span class="text-sm font-bold" [ngClass]="{
                  'text-gray-800': isScrolled,
                  'text-white': !isScrolled
                }">
                {{ customerName }}
              </span>
            </ng-container>
            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors
              bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] text-black">
              <i class="fas fa-user"></i>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</nav>


<!-- Auth Overlay -->
<app-auth-overlay
  *ngIf="showAuthOverlay"
  (closeOverlay)="closeAuthOverlay()"
></app-auth-overlay>